import React, { Component } from 'react';
import { connect } from "react-redux";
import CompanyRow from './CompanyRow';

class CompanyList extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.showSearch();
  }
  render() {
    return this.props.selection.map((company, index) =>(
      <CompanyRow
        id={index}
        name={company.name}
        description={company.description}
        tags={company.tags}
        website={company.website}
        jobs={company.jobs}
      />
    ))
  }
}

const mapStateToProps = state => {
  return {
    selection: state.selection
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  showSearch: () => dispatch({
      type: "SHOW_SEARCH",
      showSearch: true
  })
})

export default connect(mapStateToProps, mapDispatchToProps)(CompanyList);
